import TechnologyCards from "./TechnologyCards";

export default TechnologyCards;
